<div class="grid-container">
  <h3 class="page-title text-center">Dashboard</h3>

  <div class="row">
    <div *ngFor="let card of cards" [ngClass]="card.sizeQuery" style="padding: 5px">
      <lib-dashboard-card-creator [card]="card"></lib-dashboard-card-creator>
    </div>
  </div>
</div>
